import { render, staticRenderFns } from "./PopoverInfo.vue?vue&type=template&id=3615c39e&scoped=true"
import script from "./PopoverInfo.vue?vue&type=script&lang=ts"
export * from "./PopoverInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615c39e",
  null
  
)

export default component.exports